<template>
  <div class="professional">
    <h2>Professional</h2>
    <p>
      I love to learn new things. That's what really drives me. If such a
      major existed when I was in college, I would have majored in "101"
      classes. Reflecting now, I might have been able to get away with it if I
      had made the case properly. Next time!
    </p>
    <p>
      Instead, I studied chemistry. Synthetic organic chemistry drew me in
      because opened my mind to a new way of thinking. We learned to construct
      beautiful pathways from simple starting material to molecules of amazing
      complexity and utility - all without touching the molecules with your
      hands like you might with a ball-and-stick model of the same molecules.
      Synthetic organic chemistry is about constructing a series of conditions
      that make getting to the right output the most physically likely outcome.
    </p>
    <p>
      Chemistry wasn't quite the right long term fit for me - but the metaphor
      is surprisingly apt. Now I'm trying to figure out what the conditions
      are that help great teams write great software.
    </p>
    <hr/>
    <p>
      I'm the author of the
      <a href="http://eemeter.openee.io/" class="red" target="_blank">eemeter</a>
      python package for computing the avoided energy use following
      building energy efficiency projects, and the accompanying
      <a href="http://eeweather.openee.io/" class="red" target="_blank">eeweather</a>
      python package for obtaining dry bulb temperature data from various public sources.
    </p>
    <p>
      Find me on <a href="https://github.com/philngo/" class="red" target="_blank">GitHub</a> or on
      <a href="https://www.linkedin.com/in/phil-ngo-9b2b3b65/" class="red" target="_blank">LinkedIn</a>.
    </p>
    <p>
      The code for this website is
      <a href="https://github.com/philngo/philngo.me" class="red" target="_blank">on GitHub</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'professional'
}
</script>

<style scoped>
.professional {
}

hr {
  border: none;
  border-top: 1px solid #777;
}
</style>
